module.exports = __webpack_public_path__ + "img/blinking_looc_poster.448dc21f.png";